module.exports = __webpack_public_path__ + "img/fj.db3feb10.svg";